import GraphController from './graph.controller';

const GraphComponent = {
    selector: 'sbGraph',
    template: require('./graph.html'),
    controller: GraphController,
    bindings: {
        thingId: '<',
        fromDate: '<',
        toDate: '<',
        showTransport: '<',
    },
};

export default GraphComponent;



// WEBPACK FOOTER //
// ./src/app/detail/graph-component/index.js